const moment = require("moment");
let years = []

years.push(parseInt(moment().subtract(1,'years').format('YYYY')))
years.push(parseInt(moment().format('YYYY')))
years.push(parseInt(moment().add(1,'years').format('YYYY')))

export default years